import {
  landingPageData,
  landingPageData_qa,
  landingPageData_development,
} from "../Data/landingPageData";


const localisations = {
  landingPageData,
  landingPageData_qa,
  landingPageData_development
}


// note this is a little hacky for now but works for our needs
export default function useLocalisation() {
  const hostname = window.location.hostname;
  const env = getEnvFromHostname(hostname);
  return {
    landingPageData: mergeLocalisationData(
      "landingPageData",
      hostname,
      env
    )
  };
}

function mergeLocalisationData(key, hostname, environment) {
  const baseSet = localisations[key];
  const envSet = localisations[`${key}_${environment}`];

  const baseData =
    findBestDomainMatch(baseSet, hostname) || {};

  if (environment !== "production") {
    const envData =
      findBestDomainMatch(envSet, hostname) || {};

    return deepMerge(baseData, envData);
  }

  return baseData;
}

function findBestDomainMatch(config, hostname) {
  if (!config) return null;

  // Exact match first
  if (config[hostname]) {
    return config[hostname];
  }

  // Try progressively removing leftmost subdomain
  const parts = hostname.split(".");
  for (let i = 1; i < parts.length; i++) {
    const candidate = parts.slice(i).join(".");
    if (config[candidate]) {
      return config[candidate];
    }
  }

  // Fallback
  return config["default"] || null;
}
function deepMerge(target, source) {
  for (const key in source) {
    if (
      source[key] &&
      typeof source[key] === "object" &&
      !Array.isArray(source[key])
    ) {
      target[key] = deepMerge(target[key] || {}, source[key]);
    } else {
      target[key] = source[key];
    }
  }
  return target;
}

function getEnvFromHostname(hostname) {
  const parts = hostname.toLowerCase().split(".");

  if (
    parts.includes("localhost") ||
    parts.includes("development")
  ) {
    return "development";
  }
  if (
    parts.includes("qa") ||
    parts.includes("qaext")
  ) {
    return "qa";
  }

  return "production";
}